import type { RouteLocationNormalizedGeneric } from 'vue-router';

export function isAccountRoute(path: string) {
	return path.startsWith('/account');
}

export function isGuestOrPublicRoute(to: { meta?: { middleware?: unknown } }) {
	if (!to.meta?.middleware || !Array.isArray(to.meta.middleware)) return false;
	return to.meta.middleware.some(
		(m: unknown) => typeof m === 'string' && (m === 'guest' || m === 'public'),
	);
}

export function isProjectRoute(route: RouteLocationNormalizedGeneric) {
	return route.matched.some((m) => m.name === 'project-base');
}
